(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('card-grid-carousel')) {
    customElements.define(
      'card-grid-carousel',
      class CardGridCarousel extends HTMLElement {
        /* If the definition ever lands before the parser has finished this
           element, its children do not exist yet and every querySelector
           below would come back empty — so wait the parse out. */
        connectedCallback() {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
          } else {
            this.setup();
          }
        }

        setup() {
          this.scroller = this.querySelector('[data-card-grid-scroller]');
          this.previous = this.querySelector('[data-card-grid-previous]');
          this.next = this.querySelector('[data-card-grid-next]');
          this.dots = Array.from(this.querySelectorAll('[data-card-grid-dot]'));

          /* Nothing to drive: the section is in mobile-grid mode, or has a
             single card, or the merchant turned both controls off */
          if (!this.scroller || (!this.previous && !this.next && !this.dots.length)) return;

          this.onScroll = this.onScroll.bind(this);

          this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

          this.previous?.addEventListener('click', () => this.step(-1));
          this.next?.addEventListener('click', () => this.step(1));

          for (const dot of this.dots) {
            dot.addEventListener('click', () => this.scrollToCard(Number(dot.dataset.cardGridDot)));
          }

          /* The layout flips between grid and carousel at 750px, and the
             editor resizes the frame without a page load, so the reachable
             scroll range has to be re-read rather than measured once */
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.scroller);

          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.scroller?.removeEventListener('scroll', this.onScroll);
        }

        /* Not every element child is a card. snippets/group.liquid renders
           contrast-override ahead of the .group-block div, so a card with a
           background colour puts a <style> element in the row first. Counting
           those shifts every index by one: the dot for card 1 lands on card 2,
           and an arrow steps onto a <style>, whose rect is all zeros, so the
           scroll target collapses and the row never moves. */
        get cards() {
          const blocks = this.scroller.querySelectorAll(':scope > .group-block');

          if (blocks.length) return Array.from(blocks);

          return Array.from(this.scroller.children).filter((child) => child.getBoundingClientRect().width > 0);
        }

        onScroll() {
          if (this.frame) return;

          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        }

        /* Distance travelled from the start of the row. scrollLeft runs from
           0 down to -max under RTL, so read it as a magnitude. */
        get progress() {
          return Math.abs(this.scroller.scrollLeft);
        }

        get limit() {
          return this.scroller.scrollWidth - this.scroller.clientWidth;
        }

        update() {
          /* Sub-pixel scroll offsets are normal after a snap, so compare with
             a tolerance rather than against 0 exactly */
          if (this.previous) this.previous.disabled = this.progress <= 1;
          if (this.next) this.next.disabled = this.progress >= this.limit - 1;

          if (!this.dots.length) return;

          const active = this.activeIndex();

          for (const [index, dot] of this.dots.entries()) {
            dot.setAttribute('aria-current', String(index === active));
          }
        }

        /* The card whose leading edge sits closest to where the row starts.
           At the far end of a peeking carousel the last cards can never reach
           that position, so fall through to the last card once the row is
           scrolled out. */
        activeIndex() {
          const cards = this.cards;

          if (this.progress >= this.limit - 1) return cards.length - 1;

          const start = this.contentStart();
          let closest = 0;
          let smallest = Infinity;

          for (const [index, card] of cards.entries()) {
            const distance = Math.abs(this.offsetOf(card) - start);

            if (distance < smallest) {
              smallest = distance;
              closest = index;
            }
          }

          return closest;
        }

        step(direction) {
          this.scrollToCard(this.activeIndex() + direction);
        }

        scrollToCard(index) {
          const cards = this.cards;
          const card = cards[Math.max(0, Math.min(index, cards.length - 1))];

          if (!card) return;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.scroller.scrollTo({
            left: this.scroller.scrollLeft + this.offsetOf(card) - this.contentStart(),
            behavior: reduceMotion ? 'instant' : 'smooth',
          });
        }

        /* Rects rather than offsetLeft: .group-block is position: relative, so
           its offsetParent is the viewport wrapper and the numbers would be
           measured against the wrong box. */
        offsetOf(card) {
          const rect = card.getBoundingClientRect();

          return this.rtl ? rect.right : rect.left;
        }

        /* Where a card has to land to read as "first": the scroller's border
           box plus its inline padding, which is the page margin when the row
           bleeds to the screen edges. Both edges are physical x, so the delta
           between them can be added straight to scrollLeft. */
        contentStart() {
          const styles = getComputedStyle(this.scroller);
          const padding = parseFloat(styles.paddingInlineStart) || 0;
          const rect = this.scroller.getBoundingClientRect();

          return styles.direction === 'rtl' ? rect.right - padding : rect.left + padding;
        }

        get rtl() {
          return getComputedStyle(this.scroller).direction === 'rtl';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
